import type { SupplierCatalogItemDto } from '../../api/supplierCatalog'

/** Та же граница, что needs_attention в ядре: «предложено» или «без категории». */
export const needsAttention = (item: Pick<SupplierCatalogItemDto, 'matchStatus'>): boolean => {
  const status = item.matchStatus.toLowerCase()
  return status === 'suggested' || status === 'unmatched'
}

/** Особое значение фильтра статуса в «Моих прайсах» — не статус матчера, а их пара. */
export const NEEDS_ATTENTION_FILTER = 'needs_attention'
